import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";

import {offerService} from "../../services/offer.service";

const initialState = {
    offer: {}, // if we get offer by id
    status: '',
    offersByCurrentUser: [],
    alreadyAppliedOffersByCurrentUser: [],
}

const getAllOffersByCurrentUser = createAsyncThunk(
    'offerSlice/getAllOffersByCurrentUser',
    async () => {
        try {
            const {data} = await offerService.getByCurrentUser();

            return data;
        } catch (error) {
            console.log(error);
            throw error;
        }
    }
);

const getById = createAsyncThunk(
    'offerSlice/getById',
    async ({id}) => {
        try {
            const {data} = await offerService.getById(id);

            return data;
        } catch (error) {
            console.log(error);
            throw error;
        }
    }
);

const offerSlice = createSlice({
    name: 'offerSlice',
    initialState,
    reducers: {
    },
    extraReducers: builder => builder
        .addCase(getAllOffersByCurrentUser.fulfilled, (state, action) => {
            state.offersByCurrentUser = action.payload;

            state.status = 'success';
        })
        .addCase(getAllOffersByCurrentUser.pending, (state, action) => {
            state.status = 'loading';
        })

        .addCase(getById.fulfilled, (state, action) => {
            state.offer = action.payload;

            state.status = 'success';
        })
        .addCase(getById.pending, (state, action) => {
            state.status = 'loading';
        })

});

const {actions, reducer: offerReducer} = offerSlice;

const offerActions = {
    ...actions,
    // create,
    getAllOffersByCurrentUser,
    getById
}

export {
    offerActions,
    offerReducer,
}
